/**
 * Base URL of the Praxio portal (account, sign-in, SSO logout, tickets).
 *
 * Mirrors the environment detection in http-common.js, and deliberately does NOT
 * trust VUE_APP_PRAXIO_URL alone.
 *
 * Why: vue-cli inlines VUE_APP_* at BUILD time, and `.env.local` — which sets
 * VUE_APP_PRAXIO_URL=http://localhost:3000 — is loaded for production builds too
 * (it is gitignored, so it only exists on the machine doing the build). The
 * result was a production bundle whose "Back to Praxio" link, sign-in link and
 * SSO-logout redirect all pointed at http://localhost:3000.
 *
 * The env var still wins in development so a local portal on a non-default port
 * can be used; production resolves to the real host explicitly.
 *
 * PRODUCTION HOST: https://praxio.net. It was the Cloud Run service URL while
 * the domain mapping was not yet live (it did not resolve as of 2026-08-12);
 * verified serving 2026-08-24 and switched then.
 *
 * Do NOT switch it back to the run.app host. That host is now explicitly
 * non-canonical: robots.txt there answers `Disallow: /` and every canonical it
 * serves points at praxio.net, so sending signed-in users to it would put the
 * whole portal behind a duplicate hostname search engines are told to ignore.
 *
 * praxio.app is NOT ours — a third party owns it. Never use it.
 */
const isDevelopment =
  process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';

// No trailing slash: call sites append paths like `/account`.
const PRAXIO_PROD_URL = 'https://praxio.net';

export const PRAXIO_URL = isDevelopment
  ? process.env.VUE_APP_PRAXIO_URL || 'http://localhost:3000'
  : PRAXIO_PROD_URL;

export default PRAXIO_URL;
